/* int-l4-klaviyo-bis.js: moved verbatim from snippets/klaviyo-bis-fix.liquid (pdp-html-weight lever 4, 2026-11-02). Do not edit here without the source note. */
document.addEventListener('DOMContentLoaded', function () {
(function() {
  'use strict';

  var labelSrc = document.getElementById('bis-proxy-label');
  var BIS_TEXT = (labelSrc && labelSrc.textContent.trim()) || 'Notify me when back in stock';
  var proxyBtn = null;
  var suppressTimer = null;

  
  function closeRebuy() {
    try {
      if (typeof window.__intCloseCartDrawer === 'function') window.__intCloseCartDrawer();
      var nativeCart = document.getElementById('drawer-cart');
      if (nativeCart) { nativeCart.classList.remove('drawer--visible'); nativeCart.setAttribute('aria-hidden','true'); }
    } catch(e){}
  }
  function suppressRebuy() {
    document.body.classList.add('bis-suppress-rebuy');
    closeRebuy();
    [50,150,400,1000].forEach(function(ms){ setTimeout(closeRebuy, ms); });
  }
  function unsuppressRebuy() {
    document.body.classList.remove('bis-suppress-rebuy');
    clearTimeout(suppressTimer);
  }

  
  function isKlaviyoPopupOpen() {
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.nodeType !== 1) continue;
      var cls = (typeof el.className === 'string') ? el.className : '';
      if (cls.indexOf('kl-private-reset-css') === -1 && cls.indexOf('go935685458') === -1) continue;
      var st = window.getComputedStyle(el);
      if (st.display === 'none' || st.visibility === 'hidden') continue;
      if (el.querySelector('input[type="email"], [role="dialog"]')) return true;
    }
    return false;
  }
  function boostKlaviyoZIndex() {
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.nodeType !== 1) continue;
      var cls = (typeof el.className === 'string') ? el.className : '';
      if (cls.indexOf('kl-private-reset-css') === -1 && cls.indexOf('go935685458') === -1) continue;
      el.style.setProperty('z-index','2147483647','important');
    }
  }

  
  var popupWatcher = null;
  function startPopupWatcher() {
    if (popupWatcher) return;
    popupWatcher = setInterval(function() {
      if (!isKlaviyoPopupOpen()) {
        unsuppressRebuy();
        clearInterval(popupWatcher);
        popupWatcher = null;
      }
    }, 500);
    suppressTimer = setTimeout(function() {
      unsuppressRebuy();
      if (popupWatcher) { clearInterval(popupWatcher); popupWatcher = null; }
    }, 30000);
  }

  
  function hideFormError() {
    var err = document.querySelector('.add-action-errors');
    if (err) err.classList.add('bis-hide-error');
    var els = document.querySelectorAll('[data-error-display], [role="alert"]');
    for (var i = 0; i < els.length; i++) {
      if ((els[i].textContent || '').indexOf('sold out') > -1) {
        els[i].style.setProperty('display', 'none', 'important');
      }
    }
  }

  
  function isCurrentVariantSoldOut() {
    try {
      var json = document.querySelector('[data-product-json]');
      if (json) {
        var product = JSON.parse(json.textContent);
        var idInput = document.querySelector('input[name="id"]');
        if (idInput) {
          var id = parseInt(idInput.value, 10);
          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].id === id) return !product.variants[i].available;
          }
        }
      }
    } catch(e){}
    var atcBtn = document.querySelector('[data-add-to-cart]');
    return atcBtn && atcBtn.disabled;
  }

  
  function syncState() {
    var soldOut = isCurrentVariantSoldOut();
    var atcBtn = document.querySelector('[data-add-to-cart]');

    if (soldOut) {
      if (proxyBtn) proxyBtn.classList.add('is-active');
      if (atcBtn) atcBtn.classList.add('bis-hidden');
    } else {
      if (proxyBtn) proxyBtn.classList.remove('is-active');
      if (atcBtn) {
        atcBtn.classList.remove('bis-hidden');
        if (atcBtn.style.display === 'none') atcBtn.style.removeProperty('display');
      }
      hideFormError();
    }
  }

  
  function createProxy() {
    if (proxyBtn) return; /* Already created */

    
    var container = document.querySelector('.product__submit__buttons');
    if (!container) return;

    var atcBtn = container.querySelector('[data-add-to-cart]');
    if (!atcBtn) return;

    proxyBtn = document.createElement('button');
    proxyBtn.type = 'button';
    proxyBtn.id = 'bis-proxy-btn';
    proxyBtn.textContent = BIS_TEXT;

    
    container.insertBefore(proxyBtn, atcBtn);

    proxyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      suppressRebuy();
      hideFormError();

      
      var klBtn = document.querySelector('#klaviyo-bis-button-container button, #klaviyo-bis-button-container a, #klaviyo-bis-button-container .klaviyo-bis-trigger');
      if (klBtn) klBtn.click();

      [50, 100, 300, 600, 1500].forEach(function(ms) {
        setTimeout(function() {
          closeRebuy();
          boostKlaviyoZIndex();
          hideFormError();
        }, ms);
      });

      startPopupWatcher();
    }, false);

    syncState();
  }

  
  new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var n = mutations[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        var cls = (typeof n.className === 'string') ? n.className : '';
        if (cls.indexOf('kl-private-reset-css') > -1 || cls.indexOf('go935685458') > -1) {
          boostKlaviyoZIndex();
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: false });

  
  function watchFormArea() {
    var formArea = document.querySelector('.product__submit__buttons');
    if (!formArea) formArea = document.querySelector('[data-product-form-wrapper]');
    if (!formArea) return;

    new MutationObserver(function() {
      setTimeout(syncState, 100);
      setTimeout(syncState, 500);
    }).observe(formArea, { childList: true, subtree: true });

    
    var form = formArea.closest('form');
    if (form) {
      form.addEventListener('change', function() {
        [50,200,500,1000].forEach(function(ms) { setTimeout(syncState, ms); });
      });
    }
  }

  
  function init() {
    createProxy();
    watchFormArea();
    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
});
